/**
 * Hook chamado UMA vez pelo app-core (`ui/modules.tsx`): liga o manifesto, o
 * motor (plano e pré-carregamento) e as camadas do mapa, e registra o radar
 * na prontidão do quadro usada pela exportação.
 */
import { useEffect } from 'react';
import { registerFrameReadiness } from '../loop/render';
import { useMapInstance } from '../map/mapContext';
import { RadarLayerManager } from './camada';
import { instalarLeituraDoPixel } from './pixel';
import { iniciarMotorRadar } from './motor';
import { iniciarSyncRadar } from './sync';

export { refreshRadar } from './sync';

export function useRadarLayers(): void {
  const map = useMapInstance((s) => s.map);

  useEffect(() => iniciarSyncRadar(), []);

  useEffect(() => {
    if (!map) return;
    const pararMotor = iniciarMotorRadar(map);
    const manager = new RadarLayerManager(map);
    const pararProntidao = registerFrameReadiness(() => manager.whenCurrentFrameReady());
    const pararPixel = instalarLeituraDoPixel(map);
    return () => {
      pararPixel();
      pararProntidao();
      manager.dispose();
      pararMotor();
    };
  }, [map]);
}
